import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import type { UseQueryOptions } from "@tanstack/react-query";
import { get } from "../services/httpClient";
import type { Booking } from "./types";

type Props = {
  patientId: string;
  psychologistId: string;
};

export const useGetPatientBookings = <TData = Booking[]>(
  args: Props | undefined,
  options?: Pick<UseQueryOptions<Booking[], Error, TData>, "select">,
) =>
  useQuery({
    queryKey: ["patientBookings", args?.patientId, args?.psychologistId],
    queryFn: () =>
      get<{ data: Booking[] }>(
        `psychologist/patient/${args!.patientId}/slots?psychologistId=${args!.psychologistId}`,
      ).then((r) => r.data),
    enabled: !!args,
    ...options,
  });
